/* ── ANNOUNCEMENT BAR ── */
(function() {
  var msgs = document.querySelectorAll('.ann-msg');
  if (!msgs.length) return;
  var idx = 0;
  msgs[0].style.display = 'block';
  function show(i) {
    msgs.forEach(function(m) { m.style.display = 'none'; });
    msgs[i].style.display = 'block';
  }
  setInterval(function() { idx = (idx + 1) % msgs.length; show(idx); }, 4000);
  var prev = document.querySelector('.arr-nav.prev');
  var next = document.querySelector('.arr-nav.next');
  if (prev) prev.addEventListener('click', function() { idx = (idx - 1 + msgs.length) % msgs.length; show(idx); });
  if (next) next.addEventListener('click', function() { idx = (idx + 1) % msgs.length; show(idx); });
})();

/* ── HERO VIDEO ── */
(function() {
  var vid = document.getElementById('heroVideo');
  if (vid) vid.playbackRate = 0.5;
})();

/* ── GALLERY (product pages) ── */
function setImg(src, el) {
  var main = document.getElementById('main-img');
  if (main) main.src = src;
  document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
  if (el) el.classList.add('active');
}

/* ── LIGHTBOX ── */
(function() {
  var mainImg = document.getElementById('main-img');
  if (!mainImg) return;
  var lb = document.createElement('div');
  lb.id = 'lightbox';
  lb.style.cssText = 'display:none;position:fixed;inset:0;z-index:1000;background:rgba(255,255,255,0.97);align-items:center;justify-content:center;cursor:zoom-out;';
  lb.innerHTML = '<img id="lb-img" style="max-width:92vw;max-height:92vh;object-fit:contain;box-shadow:0 8px 48px rgba(0,0,0,0.15);">';
  document.body.appendChild(lb);
  lb.addEventListener('click', function() { lb.style.display = 'none'; document.body.style.overflow = ''; });
  mainImg.addEventListener('click', function() {
    document.getElementById('lb-img').src = this.src;
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { lb.style.display = 'none'; document.body.style.overflow = ''; }
  });
})();

/* ── ACCORDION ── */
function toggleAcc(el) {
  var item = el.parentElement;
  var wasOpen = item.classList.contains('open');
  document.querySelectorAll('.accordion-item.open').forEach(function(i) { i.classList.remove('open'); });
  if (!wasOpen) item.classList.add('open');
}

/* Product selector is implemented in templates/product.liquid for Shopify high-variant support. */

/* ── NEWSLETTER ── */
(function() {
  var form = document.querySelector('.newsletter-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = form.querySelector('button');
    btn.textContent = "You're on the list!";
    btn.style.background = '#56524D';
    form.querySelector('input').value = '';
    setTimeout(function() { btn.textContent = 'Subscribe'; btn.style.background = ''; }, 3000);
  });
})();

/* ── NOTIFY FORM (ready to ship) ── */
function handleNotify(e) {
  e.preventDefault();
  var btn = e.target.querySelector('button');
  btn.textContent = "You're on the list!";
  btn.style.background = '#56524D';
  e.target.querySelector('input').value = '';
  setTimeout(function() { btn.textContent = 'Notify Me'; btn.style.background = ''; }, 3000);
}


/* -- MOBILE MENU -- */
(function() {
  var btn = document.querySelector('.mob-menu-btn');
    var menu = document.getElementById('mob-menu');
      var overlay = document.getElementById('mob-menu-overlay');
        var closeBtn = document.querySelector('.mob-menu-close');
          if (!btn || !menu) return;
            function openMenu() { menu.classList.add('open'); btn.classList.add('open'); document.body.style.overflow = 'hidden'; }
              function closeMenu() { menu.classList.remove('open'); btn.classList.remove('open'); document.body.style.overflow = ''; }
                btn.addEventListener('click', openMenu);
                  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
                    if (overlay) overlay.addEventListener('click', closeMenu);
                    })();

/* ── HOMEPAGE TRANSPARENT HEADER ── */
(function(){
  var header=document.querySelector('header');
  if(!header||!document.body.classList.contains('template-index'))return;
  function updateHeader(){header.classList.toggle('is-scrolled',window.scrollY>48);}
  updateHeader();
  window.addEventListener('scroll',updateHeader,{passive:true});
})();
